// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import get_basic_detail_selector from "../../selector/get-basic-detail-selector";
import { getQuery, onClickTel } from "../../shared/function";
import MainButton from "../button/main-button";
import tel from "../../static/img/icons/tel_icon.svg";
import media_atom from "../../atom/media-atom";

// 4. 타입

const MobileBottomCard = () => {

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { detail, broker } = data;

	const media = useRecoilValue(media_atom);

	if (media === 'P' || media === 'T') return <></>

	const onClickHomepage = () => {
		window.open(broker.homepage);
	};

	return (
		<div className='mobile_register_card'>
			<div className='r_card bottom_card'>
				<h3>{detail.title}</h3>
				{broker.homepage && (
					<div>
						<MainButton title='홈페이지' types='more' onClick={onClickHomepage} />
					</div>
				)}
				{broker.tel ? (
					<div>
						<MainButton
							title={broker.tel}
							types='blue'
							front_icon={<img src={tel} alt='전화' />}
							onClick={() => onClickTel(parseInt(getQuery().idx), broker.tel)}
						/>
					</div>
				) : (
					<div>
						<MainButton
							title='등록된 정보가 없습니다.'
							types='more'
						/>
						<div className='item_warning'>
              <p>* 정보수정은 고객센터에 문의주세요.</p>
              <p>* 공짱 Tel : 1899-2296</p>
            </div>
					</div>
				)}
				<div className='reg_bottom'>
					{broker.homepage && (
						<MainButton
							title='홈페이지'
							types='more'
							fixed_secondly='fixed_top'
							onClick={onClickHomepage}
						/>
					)}
					{broker.tel ? (
						<MainButton
							title={broker.tel}
							types='blue'
							front_icon={<img src={tel} alt='전화' />}
							onClick={() => onClickTel(parseInt(getQuery().idx), broker.tel)}
						/>
					) : (
						<MainButton
							title='등록된 정보가 없습니다.'
							types='more'
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default MobileBottomCard;